<template>
  <div class="AIDetect">
      AIDetect
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: "AIDetect",
  components: {}
};
</script>
<style lang="scss" scoped>
</style>
